/**
 * FEEDBACK (C1) — as regras PURAS do formulário literal do antigo (sem JSX, para os três formulários e os testes).
 *
 * As listas `etapas_*` só aparecem quando o fluxo delas está marcado (`condicional_a: "fluxos_participa=Venda"`), e o
 * título delas é a frase de ajuda do campo de fluxos (`ajuda_etapas`). Etapas são opcionais (decisão de 05/10).
 */
import type { PerguntaDoFormulario, SecaoDoFormulario } from './feedback-store';

export type Respostas = Record<string, unknown>;

/** `true` quando a pergunta aparece com as respostas atuais. */
export function perguntaVisivel(p: PerguntaDoFormulario, respostas: Respostas): boolean {
  if (!p.condicional_a) return true;
  const [chave, valor] = p.condicional_a.split('=');
  const atual = respostas[chave];
  return Array.isArray(atual) ? atual.includes(valor) : atual === valor;
}

/** O rótulo que a pergunta mostra: o texto dela, ou — para as etapas, que não têm texto — a ajuda do campo de fluxos. */
export function rotuloDaPergunta(p: PerguntaDoFormulario, secao: SecaoDoFormulario): string | undefined {
  if (p.texto) return p.texto;
  if (!p.condicional_a) return undefined;
  const [chave] = p.condicional_a.split('=');
  return secao.perguntas.find((x) => x.id === chave)?.ajuda_etapas;
}

/** Ao desmarcar um fluxo, as etapas dele saem das respostas (o antigo não enviava o que estava escondido). */
export function semEtapasEscondidas(secoes: SecaoDoFormulario[], respostas: Respostas): Respostas {
  const fora = secoes.flatMap((s) => s.perguntas).filter((p) => p.condicional_a && !perguntaVisivel(p, respostas));
  if (!fora.length) return respostas;
  const r = { ...respostas };
  for (const p of fora) delete r[p.id];
  return r;
}

export const vazia = (v: unknown) => v === undefined || v === null || v === '' || (Array.isArray(v) && v.length === 0);
